module.exports = __webpack_public_path__ + "assets/904b1dd89aac601a110d2b85ce75c766.mp3";